<script>
	const _ = require('underscore');
	const Raphael = require('raphael');
	const GraphicTree = require('GraphicTree');
	const optimizedResize = require('utilities/optimizedResize');
	const utilities = require('utilities');

	//Measurements
	const UNIT = 80;
	const UNIT_BUFFER = 20;
	const FONT_SIZE = 17;
	const SUBTITLE_FONT_SIZE = FONT_SIZE - 3;
	const FONT_OFFSET = 4;
	const NODE_WIDTH = 4 * UNIT + UNIT_BUFFER;

	const SIBLING_SEPARATION = UNIT / 2;
	const NODE_HEIGHT = UNIT;
	const SUBTREE_SEPARATION = UNIT / 2;
	const LEVEL_SEPARATION = UNIT / 4;

	const PLUS_PATH =
		'M23.8698011,13.3928571 L23.8698011,10.1785714 C23.8698011,9.73214286 23.7115732,9.35267857 23.3951175,9.04017857 C23.0786618,8.72767857 22.6943942,8.57142857 22.2423146,8.57142857 L15.1898734,8.57142857 L15.1898734,1.60714286 C15.1898734,1.16071429 15.0316456,0.78125 14.7151899,0.46875 C14.3987342,0.15625 14.0144665,0 13.562387,0 L10.3074141,0 C9.85533454,0 9.47106691,0.15625 9.15461121,0.46875 C8.83815552,0.78125 8.67992767,1.16071429 8.67992767,1.60714286 L8.67992767,8.57142857 L1.62748644,8.57142857 C1.17540687,8.57142857 0.791139241,8.72767857 0.474683544,9.04017857 C0.158227848,9.35267857 0,9.73214286 0,10.1785714 L0,13.3928571 C0,13.8392857 0.158227848,14.21875 0.474683544,14.53125 C0.791139241,14.84375 1.17540687,15 1.62748644,15 L8.67992767,15 L8.67992767,21.9642857 C8.67992767,22.4107143 8.83815552,22.7901786 9.15461121,23.1026786 C9.47106691,23.4151786 9.85533454,23.5714286 10.3074141,23.5714286 L13.562387,23.5714286 C14.0144665,23.5714286 14.3987342,23.4151786 14.7151899,23.1026786 C15.0316456,22.7901786 15.1898734,22.4107143 15.1898734,21.9642857 L15.1898734,15 L22.2423146,15 C22.6943942,15 23.0786618,14.84375 23.3951175,14.53125 C23.7115732,14.21875 23.8698011,13.8392857 23.8698011,13.3928571 Z';

	Raphael.fn.connection = function (obj1, obj2, line, bg, style) {
		if (obj1.line && obj1.from && obj1.to) {
			line = obj1;
			obj1 = line.from;
			obj2 = line.to;
		}
		var bb1 = obj1.getBBox(),
			bb2 = obj2.getBBox(),
			p = [
				{
					x: bb1.x + bb1.width / 2,
					y: bb1.y - 1
				},
				{
					x: bb1.x + bb1.width / 2,
					y: bb1.y + bb1.height + 1
				},
				{
					x: bb1.x - 1,
					y: bb1.y + bb1.height / 2
				},
				{
					x: bb1.x + bb1.width + 1,
					y: bb1.y + bb1.height / 2
				},
				{
					x: bb2.x + bb2.width / 2,
					y: bb2.y - 1
				},
				{
					x: bb2.x + bb2.width / 2,
					y: bb2.y + bb2.height + 1
				},
				{
					x: bb2.x - 1,
					y: bb2.y + bb2.height / 2
				},
				{
					x: bb2.x + bb2.width + 1,
					y: bb2.y + bb2.height / 2
				}
			],
			d = {},
			dis = [];
		for (var i = 0; i < 4; i++) {
			for (var j = 4; j < 8; j++) {
				var dx = Math.abs(p[i].x - p[j].x),
					dy = Math.abs(p[i].y - p[j].y);
				if (
					i == j - 4 ||
					(((i != 3 && j != 6) || p[i].x < p[j].x) &&
						((i != 2 && j != 7) || p[i].x > p[j].x) &&
						((i != 0 && j != 5) || p[i].y > p[j].y) &&
						((i != 1 && j != 4) || p[i].y < p[j].y))
				) {
					dis.push(dx + dy);
					d[dis[dis.length - 1]] = [i, j];
				}
			}
		}
		if (dis.length == 0) {
			var res = [0, 4];
		} else {
			res = d[Math.min.apply(Math, dis)];
		}
		var x1 = p[res[0]].x,
			y1 = p[res[0]].y,
			x4 = p[res[1]].x,
			y4 = p[res[1]].y;
		dx = Math.max(Math.abs(x1 - x4) / 2, 10);
		dy = Math.max(Math.abs(y1 - y4) / 2, 10);
		var x2 = [x1, x1, x1 - dx, x1 + dx][res[0]].toFixed(3),
			y2 = [y1 - dy, y1 + dy, y1, y1][res[0]].toFixed(3),
			x3 = [0, 0, 0, 0, x4, x4, x4 - dx, x4 + dx][res[1]].toFixed(3),
			y3 = [0, 0, 0, 0, y1 + dy, y1 - dy, y4, y4][res[1]].toFixed(3);
		var path = ['M', x1.toFixed(3), y1.toFixed(3), 'C', x2, y2, x3, y3, x4.toFixed(3), y4.toFixed(3)].join(',');
		if (line && line.line) {
			if (line.bg) {
				line.bg.attr({
					path: path
				});
			}
			line.line.attr({
				path: path
			});
		} else {
			let lineStyle = {
				stroke: '#059fc5',
				'stroke-width': 4,
				class: 'connector-line'
			};
			if (style) {
				lineStyle = _.assign({}, lineStyle, style);
			}
			return this.path(path).attr(lineStyle);
		}

		return '';
	};

	module.exports = {
		props: ['addText', 'leafAdd', 'organizer', 'onAddClick', 'onNodeClick', 'zoomTo', 'onHelpClick'],
		data() {
			return {
				canvas: null,
				viewBox: {
					x: 0,
					y: 0,
					width: 0,
					height: 0
				},
				mousedown: false,
				mouseStartX: 0,
				mouseStartY: 0,
				mouseViewBox: null,
				lastNodeOnLevel: {},
				drawnNodes: {},
				focusNode: null,
				currentZoom: 0,
				maxZoom: 2
			};
		},
		mounted() {
			optimizedResize.add(this.resizeDraw);

			this.initOrganizer();
			this.$watch(
				function () {
					return [this.canvas, this.organizer];
				},
				() => {
					this.draw();
				},
				{
					immediate: true
				}
			);
		},
		beforeDestroy() {
			optimizedResize.remove(this.resizeDraw);
		},
		computed: {
			zoomInDisabled() {
				let currentZoom = this.currentZoom;
				let maxZoom = this.maxZoom;
				let disabled = false;
				if (currentZoom <= -1 * maxZoom) {
					disabled = true;
				}
				return disabled;
			},
			zoomOutDisabled() {
				let currentZoom = this.currentZoom;
				let maxZoom = this.maxZoom;
				let disabled = false;
				if (currentZoom >= maxZoom) {
					disabled = true;
				}
				return disabled;
			}
		},
		methods: {
			/**
			 * @param {function} callback
			 * @returns {Tree}
			 */
			positionTree: function (root) {
				this.lastNodeOnLevel = {};
				this.positionMap = {};

				this.firstWalk(root, 0);
				this.secondWalk(root, 0, 0, 0);

				return this;
			},

			/**
			 * In a first post-order walk, every node of the tree is assigned a preliminary
			 * x-coordinate (held in field node->prelim).
			 * In addition, internal nodes are given modifiers, which will be used to move their
			 * children to the right (held in field node->modifier).
			 * @param {TreeNode} node
			 * @param {number} level
			 * @returns {Tree}
			 */
			firstWalk: function (node, level) {
				node.prelim = 0;
				node.modifier = 0;

				this.setNeighbors(node, level);

				var leftSibling = node.leftSibling();

				if (node.childrenCount() === 0) {
					// set preliminary x-coordinate
					if (leftSibling) {
						node.prelim = leftSibling.prelim + NODE_HEIGHT + SIBLING_SEPARATION;
					} else {
						node.prelim = 0;
					}
				} else {
					//node is not a leaf,  firstWalk for each child
					for (var i = 0, n = node.childrenCount(); i < n; i++) {
						this.firstWalk(node.childAt(i), level + 1);
					}

					var midPoint = node.childrenCenter(UNIT) - NODE_HEIGHT / 2;

					if (leftSibling) {
						node.prelim = leftSibling.prelim + NODE_HEIGHT + SIBLING_SEPARATION;
						node.modifier = node.prelim - midPoint;
						this.apportion(node, level);
					} else {
						node.prelim = midPoint;
					}
				}
				this.positionMap[node.id] = node;
				return this;
			},

			/*
			 * Clean up the positioning of small sibling subtrees.
			 * Subtrees of a node are formed independently and
			 * placed as close together as possible. By requiring
			 * that the subtrees be rigid at the time they are put
			 * together, we avoid the undesirable effects that can
			 * accrue from positioning nodes rather than subtrees.
			 */
			apportion: function (node, level) {
				var firstChild = node.firstChild(),
					firstChildLeftNeighbor = firstChild.leftNeighbor(),
					compareDepth = 1;

				while (firstChild && firstChildLeftNeighbor) {
					// calculate the position of the firstChild, according to the position of firstChildLeftNeighbor

					var modifierSumRight = 0,
						modifierSumLeft = 0,
						leftAncestor = firstChildLeftNeighbor,
						rightAncestor = firstChild;

					for (var i = 0; i < compareDepth; i++) {
						leftAncestor = leftAncestor.parent();
						rightAncestor = rightAncestor.parent();
						modifierSumLeft += leftAncestor.modifier;
						modifierSumRight += rightAncestor.modifier;
					}

					// find the gap between two trees and apply it to subTrees
					// and mathing smaller gaps to smaller subtrees

					var totalGap = firstChildLeftNeighbor.prelim + modifierSumLeft + NODE_HEIGHT + SUBTREE_SEPARATION - (firstChild.prelim + modifierSumRight);

					if (totalGap > 0) {
						var subtreeAux = node,
							numSubtrees = 0;

						// count all the subtrees in the LeftSibling
						while (subtreeAux && subtreeAux.id !== leftAncestor.id) {
							subtreeAux = subtreeAux.leftSibling();
							numSubtrees++;
						}

						if (subtreeAux) {
							var subtreeMoveAux = node,
								singleGap = totalGap / numSubtrees;

							while (subtreeMoveAux.id !== leftAncestor.id) {
								subtreeMoveAux.prelim += totalGap;
								subtreeMoveAux.modifier += totalGap;

								totalGap -= singleGap;
								subtreeMoveAux = subtreeMoveAux.leftSibling();
							}
						}
					}

					compareDepth++;

					firstChild = firstChild.childrenCount() === 0 ? node.leftMost(0, compareDepth) : (firstChild = firstChild.firstChild());

					if (firstChild) {
						firstChildLeftNeighbor = firstChild.leftNeighbor();
					}
				}
			},

			/*
			 * During a second pre-order walk, each node is given a
			 * final x-coordinate by summing its preliminary
			 * x-coordinate and the modifiers of all the node's
			 * ancestors.  The y-coordinate depends on the height of
			 * the tree.  (The roles of x and y are reversed for
			 * RootOrientations of EAST or WEST.)
			 */
			secondWalk: function (node, level, X, Y) {
				var xTmp = node.prelim + X,
					yTmp = Y,
					levelHeight;

				levelHeight = level === 0 ? 2 * UNIT : 5 * UNIT;

				node.X = xTmp;
				node.Y = yTmp;
				// node.Y = -1 * node.Y - nodesizeTmp;

				if (node.childrenCount() !== 0) {
					this.secondWalk(node.firstChild(), level + 1, X + node.modifier, Y + levelHeight + LEVEL_SEPARATION);
				}

				if (node.rightSibling()) {
					this.secondWalk(node.rightSibling(), level, X, Y);
				}
			},
			/**
			 * Algorithm works from left to right, so previous processed node will be left neighbour of the next node
			 * @param {TreeNode} node
			 * @param {number} level
			 * @returns {Tree}
			 */
			setNeighbors: function (node, level) {
				node.leftNeighborId = this.lastNodeOnLevel[level];
				if (node.leftNeighborId) {
					node.leftNeighbor().rightNeighborId = node.id;
				}
				this.lastNodeOnLevel[level] = node.id;
				return this;
			},
			draw() {
				let organizer = this.organizer || {};
				let data = organizer.nodes;
				let allTree = new GraphicTree(data);
				let rootNode = allTree.getRoot();
				let canvas = this.canvas;

				if (canvas && rootNode) {
					this.drawnNodes = {};
					canvas.clear();

					let rootX = canvas.width / 2 - UNIT;
					let rootY = canvas.height / 2 - UNIT;
					rootNode.y = rootY;
					rootNode.x = rootX;

					// Draw Root
					rootNode.el = this.drawRootNode(rootNode);

					if (this.onAddClick) {
						this.drawEmptyNode(rootNode);
						rootNode.button = this.drawAddButton(rootNode, this.addText);
					}
					let rootChildren = rootNode.children();
					if (rootChildren && rootChildren.length) {
						//Split tree
						let rightNodes = [];
						let leftNodes = [];

						rootChildren.forEach((child, idx) => {
							let list = idx % 2 === 0 ? rightNodes : leftNodes;
							list.push(child.export());
						});

						[rightNodes, leftNodes].forEach(nodes => {
							for (let i = 0; i < nodes.length; i++) {
								let node = nodes[i];
								allTree.getChildren(node.id).forEach(child => {
									nodes.push(child.export());
								});
							}
						});

						leftNodes.unshift(
							_.assign(
								{
									root: true
								},
								rootNode.export()
							)
						);
						rightNodes.unshift(
							_.assign(
								{
									root: true
								},
								rootNode.export()
							)
						);

						let leftTree = new GraphicTree(leftNodes);
						let rightTree = new GraphicTree(rightNodes);

						this.positionTree(leftTree.getRoot());
						this.positionTree(rightTree.getRoot());

						this.drawnNodes[rootNode.id] = rootNode;

						// Draw All Children Nodes
						[rightTree, leftTree].forEach((tree, idx) => {
							let innerRootNode = tree.getRoot();
							let yOffset = rootY - innerRootNode.X;
							let xOffset = rootX - innerRootNode.Y;
							let nodesToDraw = tree.getKeys().reverse();
							let midpoint = rootNode.x + UNIT;
							let reverse = false;

							if (idx === 1) {
								reverse = true;
							}

							nodesToDraw.forEach(key => {
								let node = tree.getNode(key);
								if (node.id !== innerRootNode.id) {
									node.y = node.X + yOffset + UNIT / 2;
									node.x = node.Y + xOffset;

									if (idx === 1) {
										node.x = midpoint - (node.x - midpoint);
									}

									let el = this.drawNode(node, reverse);
									this.drawnNodes[node.id] = _.assign(
										{
											el,
											x: node.x,
											y: node.y
										},
										node.export()
									);
								}
							});
						});

						Object.keys(this.drawnNodes).forEach(key => {
							// Draw Connector
							let node = this.drawnNodes[key];
							let parentNode = this.drawnNodes[node.parentId];
							if (parentNode && parentNode.el) {
								canvas.connection(parentNode.el, node.el);
							}

							if (this.leafAdd) {
								this.drawAddButton(this.drawnNodes[node.id], null, node.x < rootNode.x);
							}

							if (this.focusNode && this.focusNode === key) {
								this.zoomToNode(node);
								this.focusNode = null;
							}
						});
					}
				}
			},
			drawNode(node, reverse) {
				let canvas = this.canvas;
				let items = [];
				let el = null;

				if (node && node.id) {
					let currentX = node.x;
					let currentY = node.y;
					let previousShape = null;

					if (reverse) {
						currentX -= 2 * UNIT;
					}

					if (node.linkText) {
						let shape = canvas.rect(currentX, currentY, 2 * UNIT, UNIT, UNIT / 2);
						shape.attr({
							class: 'link-node',
							cursor: 'pointer',
							fill: '#FFF',
							stroke: '#059fc5',
							'stroke-width': 2
						});

						let textStr = this.linebreakText(node.linkText, 25);
						let word = canvas.text(currentX + UNIT, currentY + 0.5 * UNIT, textStr);
						word.attr({
							class: 'link-node-text',
							fill: '#222',
							cursor: 'pointer',
							'text-anchor': 'middle',
							'font-family': 'var(--custom-font-family, var(--font-helvetica))',
							'font-size': '17px',
							'font-weight': 'bold',
							title: node.linkText
						});

						items.push(shape);
						items.push(word);
						previousShape = shape;

						if (reverse) {
							currentX -= 2 * UNIT + UNIT_BUFFER;
						} else {
							currentX += 2 * UNIT + UNIT_BUFFER;
						}
					}

					if (node.word) {
						let shape = canvas.rect(currentX, currentY, 2 * UNIT, UNIT, UNIT / 2);
						shape.attr({
							cursor: 'pointer',
							fill: '#FFF',
							stroke: '#059fc5',
							'stroke-width': 2
						});

						let word = canvas.text(currentX + UNIT, currentY + 0.5 * UNIT, node.word);
						word.attr({
							fill: '#222',
							cursor: 'pointer',
							'text-anchor': 'middle',
							'font-family': 'var(--custom-font-family, var(--font-helvetica))',
							'font-size': '17px',
							'font-weight': 'bold',
							title: node.word
						});

						items.push(shape);
						items.push(word);
						if (previousShape) {
							canvas.connection(previousShape, shape);
						}
					}
					el = canvas.set(items);
					if (this.onNodeClick) {
						el.click(() => this.onNodeClickInternal(node));
					}
				}

				return el;
			},
			drawEmptyNode(node) {
				let canvas = this.canvas;
				let items = [];
				let set = null;

				if (node && node.id) {
					let currentX = node.x;
					let currentY = node.y - 1.4 * NODE_HEIGHT;
					let previousShape = null;

					let shape = canvas.rect(currentX, currentY, 2 * UNIT, UNIT, UNIT / 2);
					shape.attr({
						class: 'link-node empty',
						cursor: 'pointer',
						fill: '#FFF',
						stroke: '#059fc5',
						'stroke-width': 2,
						opacity: 0.3
					});

					items.push(shape);
					canvas.connection(node.el, shape, null, null, {
						opacity: 0.3
					});
					previousShape = shape;

					currentY -= 1.2 * NODE_HEIGHT;

					shape = canvas.rect(currentX, currentY, 2 * UNIT, UNIT, UNIT / 2);
					shape.attr({
						class: 'empty',
						cursor: 'pointer',
						fill: '#FFF',
						stroke: '#059fc5',
						'stroke-width': 2,
						opacity: 0.3
					});

					items.push(shape);
					canvas.connection(previousShape, shape, null, null, {
						opacity: 0.3
					});

					set = canvas.set(items);

					if (this.onAddClick) {
						set.click(() => this.onAddButtonClick(node));
					}
				}

				return set;
			},
			drawAddButton(node, addText, reverse) {
				let canvas = this.canvas;
				let width = UNIT / 2;
				let height = UNIT / 2;
				let x = null;
				let y = null;

				if (node.root) {
					x = node.x + (UNIT - width / 2);
					y = node.y - 0.25 * UNIT;
				} else if (reverse) {
					x = node.x - NODE_WIDTH - 0.5 * width;
					y = node.y + UNIT / 2 - width / 2;
				} else {
					x = node.x + NODE_WIDTH - 0.5 * width;
					y = node.y + UNIT / 2 - width / 2;
				}

				let shape = canvas.rect(x, y, width, height, UNIT);
				shape.attr({
					fill: '#059fc5',
					cursor: 'pointer',
					stroke: '#059fc5',
					'stroke-width': 1
				});

				let plus = canvas.path(PLUS_PATH);
				plus.attr({ transform: ['t', x + 8, y + 8] });
				plus.attr({
					fill: '#FFF',
					stroke: 'none',
					cursor: 'pointer'
				});

				if (addText) {
					let text = canvas.text(x + height / 2, y - height - FONT_OFFSET, addText);
					text.attr({
						fill: '#059fc5',
						cursor: 'pointer',
						'text-anchor': 'middle',
						'font-family': 'var(--custom-font-family, var(--font-helvetica))',
						'font-size': '24px',
						'font-weight': 'bold'
					});
				}

				let set = canvas.set([shape, plus]);
				set.click(() => this.onAddButtonClick(node));
				return set;
			},
			drawRootNode(node) {
				let canvas = this.canvas;
				let shape = canvas.rect(node.x, node.y, 2 * UNIT, 2 * UNIT, UNIT);
				let word = null;
				let text = null;
				let items = [shape];

				shape.attr({
					fill: '#FFF',
					cursor: 'pointer',
					stroke: '#222',
					'stroke-width': 2
				});

				if (node.word && node.text) {
					let maxDefLines = 5;
					let textStr = this.linebreakText(node.word, 20);
					let definition = this.linebreakText(node.text, 20, maxDefLines);
					let defLines = 0;
					let textLines = 0;
					if (textStr && textStr.indexOf('\n') !== -1) {
						textLines = textStr.match(/\n/g).length + 1;
					}
					if (definition && definition.indexOf('\n') !== -1) {
						defLines = definition.match(/\n/g).length + 1;
					}

					let lineAdjustment = Math.max(maxDefLines - defLines - textLines, 0);
					let textAdjustment = Math.min(lineAdjustment * SUBTITLE_FONT_SIZE, SUBTITLE_FONT_SIZE);
					word = canvas.text(node.x + UNIT, node.y + 0.45 * UNIT + textAdjustment, textStr);
					text = canvas.text(node.x + UNIT, node.y + 1.2 * UNIT, definition);
				} else if (node.word) {
					let textStr = this.linebreakText(node.word, 20);
					word = canvas.text(node.x + UNIT, node.y + UNIT - FONT_OFFSET, textStr);
				}

				if (word) {
					word.attr({
						fill: '#222',
						cursor: 'pointer',
						'text-anchor': 'middle',
						'font-family': 'var(--custom-font-family, var(--font-helvetica))',
						'font-size': FONT_SIZE + 'px',
						'font-weight': 'bold'
					});
					items.push(word);
				}

				if (text) {
					text.attr({
						fill: '#222',
						cursor: 'pointer',
						'text-anchor': 'middle',
						'font-family': 'var(--custom-font-family, var(--font-helvetica))',
						'font-size': SUBTITLE_FONT_SIZE + 'px',
						title: node.text
					});
					items.push(text);
				}
				let set = canvas.set(items);
				if (this.onNodeClick) {
					set.click(() => this.onNodeClick(node));
				}
				return set;
			},
			linebreakText(text, maxlength = 20, maxlines = 4) {
				return utilities.linebreakStr(text, maxlength, maxlines);
			},
			initOrganizer() {
				let frameEl = this.$refs.canvasFrame;
				if (frameEl && frameEl.offsetWidth && frameEl.offsetHeight) {
					let width = frameEl.offsetWidth - 2;
					let height = frameEl.offsetHeight - 2;
					let canvas = Raphael(frameEl, width, height);

					this.canvas = canvas;
					this.viewBox = this.setViewBox(0, 0, width, height);
					this.currentZoom = 0;
				}
			},
			resizeDraw: _.debounce(function () {
				let canvas = this.canvas;
				let frameEl = this.$refs.canvasFrame;
				if (canvas && frameEl && frameEl.offsetWidth && frameEl.offsetHeight) {
					let width = frameEl.offsetWidth - 2;
					let height = frameEl.offsetHeight - 2;

					canvas.setSize(width, height);
					this.viewBox = this.setViewBox(0, 0, width, height);
					this.currentZoom = 0;
				}
			}, 500),
			setViewBox(x, y, width, height) {
				let canvas = this.canvas;
				canvas.setViewBox(x, y, width, height);
				return {
					x,
					y,
					width,
					height
				};
			},
			zoomToNode(node) {
				let viewBox = this.viewBox;
				if (viewBox && node) {
					let width = viewBox.width;
					let height = viewBox.height;
					let x = node.x - width / 2 + NODE_WIDTH / 2;
					let y = node.y - height / 2 + NODE_HEIGHT / 2;
					this.viewBox = this.setViewBox(x, y, width, height);
				}
			},
			onMouseDown(e) {
				let canvas = this.canvas;
				let viewBox = this.viewBox;
				let viewBoxWidth = viewBox.width;
				let viewBoxHeight = viewBox.height;
				let pageX = e.pageX || (e.targetTouches[0] && e.targetTouches[0] && e.targetTouches[0].clientX);
				let pageY = e.pageY || (e.targetTouches[0] && e.targetTouches[0] && e.targetTouches[0].clientY);
				if (canvas.getElementByPoint(pageX, pageY) != null) {
					return;
				}
				this.mousedown = true;
				this.mouseStartX = pageX;
				this.mouseStartY = pageY;
				this.mouseViewBox = this.setViewBox(viewBox.x, viewBox.y, viewBoxWidth, viewBoxHeight);
			},
			onMouseMove(e) {
				let canvas = this.canvas;
				let viewBox = this.viewBox;
				let viewBoxWidth = viewBox.width;
				let viewBoxHeight = viewBox.height;
				let mousedown = this.mousedown;
				let startX = this.mouseStartX;
				let startY = this.mouseStartY;
				let pageX = e.pageX || (e.targetTouches[0] && e.targetTouches[0] && e.targetTouches[0].clientX);
				let pageY = e.pageY || (e.targetTouches[0] && e.targetTouches[0] && e.targetTouches[0].clientY);

				if (mousedown === false) {
					return;
				}
				let dX = startX - pageX;
				let dY = startY - pageY;
				let x = viewBoxWidth / canvas.width;
				let y = viewBoxHeight / canvas.height;

				dX *= x;
				dY *= y;

				this.mouseViewBox = this.setViewBox(viewBox.x + dX, viewBox.y + dY, viewBoxWidth, viewBoxHeight);
			},
			onMouseUp() {
				let mousedown = this.mousedown;
				let mouseViewBox = this.mouseViewBox;

				if (!mouseViewBox || mousedown === false) return;

				this.viewBox = mouseViewBox;
				this.mouseViewBox = null;
				this.mousedown = false;
			},
			onRefreshClick() {
				let canvas = this.canvas;
				this.viewBox = this.setViewBox(0, 0, canvas.width, canvas.height);
				this.currentZoom = 0;
				// this.draw();
			},
			onAddButtonClick(node) {
				this.onAddClick(node);
			},
			onNodeClickInternal(node) {
				this.onNodeClick(node);
			},
			zoom(delta) {
				let viewBox = this.viewBox;
				let canvas = this.canvas;
				let canvasWidth = canvas.width;
				let canvasHeight = canvas.height;
				let viewBoxWidth = viewBox.width;
				let viewBoxHeight = viewBox.height;
				let vBHo = viewBoxHeight;
				let vBWo = viewBoxWidth;
				let diff = 0.2;
				let zoomAmount = 0;
				if (delta < 0) {
					this.currentZoom -= 1;
				} else {
					this.currentZoom += 1;
				}

				// Zoom based on original canvas size and currentZoom factor
				zoomAmount = 1 + diff * this.currentZoom;
				viewBoxWidth = zoomAmount * canvasWidth;
				viewBoxHeight = zoomAmount * canvasHeight;

				// Translate current position
				let x = viewBox.x - (viewBoxWidth - vBWo) / 2;
				let y = viewBox.y - (viewBoxHeight - vBHo) / 2;

				this.viewBox = this.setViewBox(x, y, viewBoxWidth, viewBoxHeight);
			},
			onZoomInClick() {
				if (!this.zoomInDisabled) {
					this.zoom(-1);
				}
			},
			onZoomOutClick() {
				if (!this.zoomOutDisabled) {
					this.zoom(1);
				}
			}
		},
		watch: {
			zoomTo: {
				handler(id) {
					this.focusNode = id;
					if (this.canvas && this.organizer) {
						this.draw();
					}
				},
				immediate: true
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.graphic-organizer {
		position: relative;

		.canvas-frame {
			border: 1px solid $c-grey;
			min-height: 600px;
			z-index: 3;

			svg {
				cursor: move;
				z-index: 2;

				path,
				rect,
				text,
				tspan {
					z-index: 2;
				}

				path.connector-line {
					stroke-dasharray: 4, 3;
				}
			}
		}

		.graphic-organizer-toolbar {
			position: absolute;
			margin: 0.5rem;
			bottom: 0;
			right: 0;
			z-index: 3;
		}
	}

	// @media only screen and (min-width: $bp-width-med) {

	// }
</style>
<template>
	<div class="graphic-organizer">
		<div
			class="canvas-frame"
			ref="canvasFrame"
			@mousedown="onMouseDown"
			@mousemove="onMouseMove"
			@mouseup="onMouseUp"
			@touchstart="onMouseDown"
			@touchmove="onMouseMove"
			@touchend="onMouseUp"></div>
		<div class="graphic-organizer-toolbar">
			<button
				class="button"
				:class="{
					disabled: zoomInDisabled
				}"
				aria-label="Zoom in"
				@click="onZoomInClick">
				<i
					class="fa-solid fa-magnifying-glass-plus"
					aria-hidden="true"></i>
			</button>
			<button
				class="button"
				:class="{
					disabled: zoomOutDisabled
				}"
				aria-label="Zoom out"
				@click="onZoomOutClick">
				<i
					class="fa-solid fa-magnifying-glass-minus"
					aria-hidden="true"></i>
			</button>
			<button
				class="button"
				aria-label="Refresh"
				@click="onRefreshClick">
				<i
					class="fa-solid fa-rotate"
					aria-hidden="true"></i>
			</button>
			<button
				v-if="onHelpClick"
				class="button"
				aria-label="Help"
				@click="onHelpClick">
				<i
					class="fa-solid fa-circle-question"
					aria-hidden="true"></i>
			</button>
		</div>
	</div>
</template>
